export const AllScreens = [
    { value: "", label: "Selecionar a tela..." },
    { value: "home", label: "Home" },
    { value: "financial", label: "I. Análise Financeira" },
    { value: "projects", label: "II.0 Informações de Projetos" },
    { value: "lines", label: "II.1 Buscador de Linhas" },
    { value: "recommendation", label: "III. Recomendação" },
    { value: "files", label: "Gerenciamento de Documento" },
    { value: "news", label: "Notícias" }
];

export const AllActions = [
    { value: "", label: "Selecionar a ação..." },
    { value: "delete", label: "Exclusão" },
    { value: "see", label: "Visualização" },
    { value: "create", label: "Criação" },
    { value: "edit", label: "Edição" },
    { value: "upload", label: "Upload" },
    { value: "download", label: "Download" }
];

export const AllSeverities = [
    { value: "", label: "Selecionar a severidade..." },
    { value: "low", label: "Baixo Impacto" },
    { value: "medium", label: "Médio Impacto" },
    { value: "high", label: "Alto Impacto" }
];